import React from "react";
import Box from "@mui/material/Box";

const Map = ({ themeMode = "light" }) => {
  return (
    <Box>
      <Box
        component={"iframe"}
        borderRadius={2}
        minHeight={300}
        width="100%"
        height="100%"
        frameBorder="0"
        title="map"
        marginHeight="0"
        marginWidth="0"
        scrolling="no"
        src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=20B,%20Soetan%20Street,%20Asero%20Estate%20Asero,%20Abeokuta,%20Ogun%20State,%20Nigeria+(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
        sx={{
          filter: themeMode === "dark" ? "grayscale(0.5) opacity(0.7)" : "none",
        }}
      />
    </Box>
  );
};

export default Map;
